import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import api from '@/services/api'

Vue.use(Vuex)

const vuexPersist = new VuexPersist({
  key: 'topazio',
  storage: window.localStorage,
  reducer: (state) => ({
    // Persistir apenas dados de produto (navegação sempre busca fresh)
    product_details: state.product_details,
    category: state.category,
    ramdom_products: state.ramdom_products
  })
})

const store = new Vuex.Store({
  state: {
    // Navegação (do API) - sem valores padrão
    navigation: {
      menu: [],
      productCategories: [],
      config: {}
    },
    navigationLoaded: false,

    // Produtos (legado)
    product_details: {
      name: ''
    },
    category: '',
    ramdom_products: []
  },

  mutations: {
    // Navegação (vazio se API não retornar)
    setNavigation (state, payload) {
      const data = payload || {}
      state.navigation = {
        menu: Array.isArray(data.menu) ? data.menu : [],
        productCategories: Array.isArray(data.productCategories) ? data.productCategories : [],
        config: data.config || {}
      }
      state.navigationLoaded = true
    },

    // Produtos (legado)
    setProduct (state, payload) {
      state.product_details = payload.product
      state.category = payload.category
      const ramdom = require('@/database/' + state.category + '.json')
      const products = []
      for (let i = 0; i < 4; i++) {
        products.push(ramdom.items[Math.floor(Math.random() * ramdom.items.length)])
      }
      const ramdomProducts = products.filter(function (p, i) {
        return products.indexOf(p) === i
      })
      state.ramdom_products = ramdomProducts
    }
  },

  actions: {
    async fetchNavigation ({ commit, state }) {
      // Evita múltiplas requisições
      if (state.navigationLoaded) return state.navigation

      try {
        const data = await api.getNavigation()
        // Só faz commit se recebeu dados válidos
        if (data && typeof data === 'object') {
          commit('setNavigation', data)
          return data
        }
        // Se não recebeu dados válidos, mantém os valores padrão
        state.navigationLoaded = true
        return state.navigation
      } catch (error) {
        console.error('Erro ao carregar navegação:', error)
        // Marca como carregado para não tentar novamente
        state.navigationLoaded = true
        // Mantém os valores padrão em caso de erro
        return state.navigation
      }
    }
  },

  getters: {
    // Navegação (com fallbacks para evitar erros)
    menuItems: state => state.navigation?.menu || [],
    productCategories: state => state.navigation?.productCategories || [],
    siteConfig: state => state.navigation?.config || {},

    // Produtos
    productDetails: state => state.product_details,
    currentCategory: state => state.category,
    relatedProducts: state => state.ramdom_products
  },

  plugins: [vuexPersist.plugin]
})

Vue.prototype.$store = store

export default store